export default __webpack_public_path__ + "static/media/person_3.c54dad87.png";